import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { useRecoilValue } from 'recoil'
import { isOpenOverlayState } from '../../globalStates/isOpenOverlayState'

export default function LoadingOverlay() {
  const open : boolean = useRecoilValue(isOpenOverlayState) 
  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  )
}